export enum AmountType {
  Expense = 0,
  Income = 1,
}
